/**
 * @generated SignedSource<<6490a891ed01311111cf8c23dc8a646b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TimelineEntriesField_User$data = {
  readonly profile: {
    readonly industry: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly timelineEntries: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"TimelineEntriesField_TimelineEntries">;
  }> | null | undefined;
  readonly " $fragmentType": "TimelineEntriesField_User";
};
export type TimelineEntriesField_User$key = {
  readonly " $data"?: TimelineEntriesField_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimelineEntriesField_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimelineEntriesField_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Industry",
          "kind": "LinkedField",
          "name": "industry",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimelineEntry",
      "kind": "LinkedField",
      "name": "timelineEntries",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TimelineEntriesField_TimelineEntries"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "56bfab9201eb217303eb8afb5a61d6ff";

export default node;
